import { gql } from "graphql-request";
import { IMAGE_FRAGMENT } from "./fragments";

/**
 * Query: Fetches detailed MICE (Meetings, Incentives, Conferences, and Exhibitions) page data.
 * Includes banners, inquiry form info, meeting room details, search results, and regional data.
 */
export const GET_MICE_DETAIL_DATA = gql`
  ${IMAGE_FRAGMENT}
  query MiceDetailItem(
    $locale: I18NLocaleCode
    $documentId: ID!
    $status: PublicationStatus
  ) {
    basePage(documentId: $documentId, locale: $locale, status: $status) {
      item_name
      documentId
      datasource {
        banner: hero_banner_datasources {
          information {
            background_image {
              ...ImageUrlProperties
            }
          }
        }
        inquiry_form_datasource {
          main_title
          sub_title
          telephone_label
          telephone_number
          form_button_label
          inquiry_link
          button_label_2
          link_2
        }
        mice_detail_datasources {
          mice_detail_list_datasources {
            detail_list
            text {
              heading
              description
              counter_label
              more_text
            }
          }
          mice_detail_text_datasources {
            website_link_label
            form_label
            more_link_label
            mice_page_link_label
            pdf_download_label
            step_label
          }
        }
        search_result_datasources {
          total_meeting_rooms_label
          max_capacity_label
          total_sq_guest_room_label
          types_label
          max_capacity_people_label
          total_sq_guest_room_types_label
          search_result_resource {
            header
            download_pdf_label
            website_link_label
            request_rpf_button_label
            selected_regions
          }
        }
      }
      mice_detail {
        documentId
        item_name
        text {
          top_title
          subtitle_title
          description
          selected_hotel
        }
        lists_and_images {
          hotel_image {
            ...ImageUrlProperties
          }
          relative_details
          region
          activity_list
          details_image {
            ...ImageUrlProperties
          }
          hotel_image {
            ...ImageUrlProperties
          }
        }
        activities {
          documentId
          title
          description
          time
          image {
            ...ImageUrlProperties
          }
        }
      }
      regions {
        documentId
        labels {
          name
          meetings_hotel_list
        }
      }
    }
  }
`;

/**
 * Query: Fetches individual hotel details for MICE pages.
 * Includes guest room data, floor plans, and meeting space info.
 */
export const GET_HOTEL_DETAIL = gql`
  query MiceDetailItemHotel(
    $status: PublicationStatus
    $locale: I18NLocaleCode
    $documentId: ID!
  ) {
    japanHotel(documentId: $documentId, locale: $locale, status: $status) {
      item_name
      documentId
      properties {
        total_guest_rooms
        hotel_name
        prefecture
        floor_plan {
          cloudflare_url
          url
          previewUrl
        }
      }
      meetings_space {
        max_capacity
        number_of_rooms
        bottom_phone_number
      }
      slug
    }
  }
`;

/**
 * Query: Retrieves localized validation messages for MICE inquiry forms.
 * Used for field-level error handling and form validation.
 */
export const GET_MICE_FORM_VALIDATION_MESSAGES = gql`
  query MiceFormValidationMessages(
    $locale: I18NLocaleCode
    $status: PublicationStatus
    $documentIds: [ID!]
  ) {
    messageDatasources(
      locale: $locale
      status: $status
      filters: { documentId: { in: $documentIds } }
    ) {
      item_name
      properties {
        key
        value
      }
    }
  }
`;
